import apiClient from '../api/apiClient'
import { CompanyDetail, CompanySummary, CreateCompanyPayload, UpdateCompanyPayload } from '../../types/company'

const base = '/dev/companies'

export const companyService = {
  async list(params?: { search?: string; status?: string }): Promise<CompanySummary[]> {
    const response = await apiClient.get<CompanySummary[]>(base, { params })
    return response.data
  },
  async get(id: string): Promise<CompanyDetail> {
    const response = await apiClient.get<CompanyDetail>(`${base}/${id}`)
    return response.data
  },
  async create(payload: CreateCompanyPayload): Promise<{ company: CompanyDetail; initial_admin_id: string }> {
    const response = await apiClient.post<{ company: CompanyDetail; initial_admin_id: string }>(base, payload)
    return response.data
  },
  async update(id: string, payload: UpdateCompanyPayload): Promise<CompanyDetail> {
    const response = await apiClient.patch<CompanyDetail>(`${base}/${id}`, payload)
    return response.data
  },
  async setStatus(id: string, status: 'active' | 'suspended'): Promise<{ _id: string; status: string; updatedAt: string }> {
    const response = await apiClient.patch<{ _id: string; status: string; updatedAt: string }>(`${base}/${id}/status`, { status })
    return response.data
  },
}
